import { useState } from "react";
import { InputErros, value } from "../../helpers";
import {
  Button,
  Grid,
  IconButton,
  Loading,
  Dialog,
  InputAdornment,
  TextField,
  DialogContent,
  CardContent,
} from "..";
import { MeuUsuarioService, notification } from "../../services";
import { responseErros } from "../../utils";
import { loginValidator } from "./middlewares";
import palette from "../../styles/dark-theme/palette";

const PermissionDialog = ({ dialog }) => {
  const [login, setLogin] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [tempoBloqueio, setTempoBloqueio] = useState("5:00");
  const [usuarioBloqueado, setUsuarioBloqueado] = useState(false);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState(false);
  const [inputErro, setInputErro] = useState([]);

  const inputErros = new InputErros(inputErro, setInputErro);
  const meuUsuarioService = new MeuUsuarioService();

  const onSubmitLogar = (event) => {
    event.preventDefault();
    setErro(false);
    loginValidator
      .validate(login, { abortEarly: false })
      .then(logar())
      .catch((err) => inputErros.set(err));
  };

  const logar = async () => {
    setLoading(true);
    const res = await meuUsuarioService.validarPermissao(
      login,
      dialog.permissao
    );
    setLoading(false);
    if (!res.isAxiosError) {
      dialog.onValidate(res.data || false);
    } else {
      if (res.response && res.response.status == 400) {
        setErro(true);
        notification.alertaGenericos(
          res.response.data.message || res.response.data
        );
        if (
          res.response.data.message ==
          "Este usuário está bloqueado temporariamente"
        ) {
          bloquearUsuario();
        }
      } else {
        responseErros(res);
      }
    }
  };

  function onCloseDialog() {
    setLogin({});
    dialog.onClose();
  }

  const onChangeInput = (event) => {
    setLogin((prevState) => ({
      ...prevState,
      [event.target.name]: String(event.target.value).trim(),
    }));
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  function bloquearUsuario() {
    setUsuarioBloqueado(true);
    let minutos = 4;
    let segundos = 60;
    const interval = setInterval(() => {
      segundos--;
      if (segundos == 0) {
        if (minutos == 0) {
          setTempoBloqueio("5:00");
          setUsuarioBloqueado(false);
          clearInterval(interval);
          return;
        }
        segundos = 60;
        minutos--;
      }
      const segundosFormatado = segundos < 10 ? `0${segundos}` : segundos;
      setTempoBloqueio(`${minutos}:${segundosFormatado}`);
    }, 1000);
  }

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      PaperComponent="div"
      PaperProps={{
        style: {
          borderRadius: "0.7rem",
          background: `linear-gradient(180deg, ${palette.white} 98%, ${palette.white} 98%, ${palette.primary.main} 2%)`,
        },
      }}
      open={dialog.open}
      onClose={() => onCloseDialog()}
    >
      <DialogContent>
        <h6 className="text-center text-uppercase fw-bold pt-2">
          Validar Permissão
        </h6>
        <p className="text-center text-capitalize">
          {dialog?.descricaoPermissao || ""}
        </p>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {usuarioBloqueado && (
                <span className="text-danger">
                  Usuário bloqueado por {tempoBloqueio}
                </span>
              )}
              <form className="mt-2" onSubmit={onSubmitLogar}>
                <TextField
                  variant="outlined"
                  id="email"
                  name="email"
                  label="E-mail"
                  type="text"
                  margin="normal"
                  fullWidth
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(event) => onChangeInput(event)}
                  value={value.text(login.email)}
                  error={inputErros.get("email") || erro ? true : false}
                />
                <TextField
                  variant="outlined"
                  label="Senha"
                  name="senha"
                  id="senha"
                  margin="normal"
                  fullWidth
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                  type={showPassword ? "text" : "password"}
                  onChange={(event) => onChangeInput(event)}
                  value={value.text(login.senha)}
                  error={inputErros.get("senha") || erro ? true : false}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={handleClickShowPassword}>
                          {showPassword ? (
                            <i
                              className="ph-fill ph-eye"
                              style={{ color: "#494C62", fontSize: 18 }}
                            ></i>
                          ) : (
                            <i
                              className="ph-fill ph-eye-slash"
                              style={{ color: "#494C62", fontSize: 18 }}
                            ></i>
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <Button
                  fullWidth
                  variant="contained"
                  disabled={usuarioBloqueado || loading}
                  size="large"
                  type="submit"
                  className="mt-3 rounded-3"
                  color={usuarioBloqueado ? "padrao" : "primary"}
                  disableElevation
                >
                  Entrar
                </Button>
                <Button
                  fullWidth
                  variant="contained"
                  size="large"
                  onClick={() => onCloseDialog()}
                  className="mt-2 rounded-3"
                  color="padrao"
                  disableElevation
                >
                  Fechar
                </Button>
              </form>
            </Grid>
          </Grid>
        </CardContent>
      </DialogContent>
      <Loading loading={loading} />
    </Dialog>
  );
};

export default PermissionDialog;
